import VBaseCheckboxRadioContext from './context';

const useBaseCheckboxRadio = VBaseCheckboxRadioContext.hook;

export default useBaseCheckboxRadio;
